import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getItemIcon } from './fileTypes'
import { useEffect, useRef } from 'react'
import {
  faArrowRight,
  faArrowsAltV,
  faCheck,
  faEdit,
  faFileMedical,
  faFolder,
  faFolderPlus,
  faLink,
  faStickyNote,
  faTableCells,
  faTableList,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'

import BreadCrumb from './components/BreadCrumb'
import ReoderItems from './components/ReorderItems'
import LibItem from './components/LibItem'
import FileLink from './components/FileLink'
import Upload from './components/Upload'
import UpdateFile from './components/UpdateFile'
import AddFolder from './components/AddFolder'
import UploadHomework from './components/UploadHomework'
import ViewLibraryPDF from './components/ViewLibraryPDF'
import MyDocuments from './components/MyDocuments'
import ViewNote from './components/ViewNote'
import AreYouSureModal from 'views/pages/Recruitment/AreYouSureModal'
import './styles/styles.css'

import {
  Link,
  Route,
  Redirect,
  useLocation,
  useParams,
  useHistory,
} from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { fetchOrgGroups } from 'store/OrgGroup/actions'
import { fetchGroups } from 'store/Group/actions'
import { fetchUsers } from 'store/Users/actions'
import { fetchStores } from 'store/Stores/actions'
import { fetchRoles } from 'store/Role/actions'
// import { fetchCourseSettings } from 'store/ConfigurationSettings/CourseConfig/actions'
import Loader from '../Loader'
import Search from '../Search'
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  Row,
  Spinner,
  UncontrolledDropdown,
} from 'reactstrap'

import * as libraryActions from 'store/Library/actions'
import { useState } from 'react'
import { selectRole } from 'store/Library/actions'
import Select from '../Group/Select'
import CustomModalHeader from 'components/Custom/CustomModalHeader'
import CustomModalFooter from 'components/Custom/CustomModalFooter'
import UrlModal from './components/UrlModal'
import { filterFilesMulti } from 'store/Library/actions'

// Internal keys stay 'Brands' / 'Locations' (the API checks for 'Locations');
// these are what users see.
const FILTER_LABELS = {
  Brands: 'Location Groups',
  Locations: 'Locations',
}

const Library = (props) => {
  const library = useSelector((state) => state.library)
  const groupOrgs = useSelector((state) => state.orgGroups.orgGroups)
  const groups = useSelector((state) => state.groups?.locationGroups)
  const user = useSelector((state) => state.users)
  const stores = useSelector((state) => state.stores.stores)
  const roles = useSelector((state) => state.roles.roles)
  const language = useSelector((state) => state.language?.language?.data)
  const courseConfig = useSelector((state) => state.courseConfig)
  const { access: userAccess, allow_switch_roles: allowSwitchRoles } =
    useSelector((state) => state.auth.user)



  const [gridView, setGridView] = useState(true)
  const [showUrlModal, setShowUrlModal] = useState(false)
  const [showNoteModal, setShowNoteModal] = useState(false)
  const [selectedNote, setSelectedNote] = useState(null)

  const dispatch = useDispatch()
  const location = useLocation()
  const params = useParams()
  const history = useHistory()

  // Becomes true after the first load of this page visit.
  const hasLoadedLibrary = useRef(false)

  // Load a folder only when we actually move to a different one. Modals (note,
  // add, edit, url viewer) are routes too, but they sit on top of the folder that
  // is already loaded, so opening/closing them must not refetch or show the loader.
  useEffect(() => {
    const folderMatch = location.pathname.match(/^\/library\/folder\/(\d+)$/)
    const noteMatch = location.pathname.match(/^\/library\/note\/(\d+)$/)

    let targetFolderId
    if (folderMatch) {
      targetFolderId = parseInt(folderMatch[1])
    } else if (location.pathname === '/library') {
      targetFolderId = null
    } else if (noteMatch && !hasLoadedLibrary.current) {
      // Deep link straight to a note: nothing is loaded yet.
      targetFolderId = null
    } else {
      return
    }

    if (
      hasLoadedLibrary.current &&
      (library.parentId ?? null) === targetFolderId
    ) {
      return
    }

    hasLoadedLibrary.current = true
    dispatch(libraryActions.fetchFiles(targetFolderId))
  }, [location.pathname]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const noteMatch = location.pathname.match(/^\/library\/note\/(\d+)$/)
    if (noteMatch) {
      const noteId = parseInt(noteMatch[1])
      const note =
        library.files.find((f) => f.id === noteId) ||
        library.allLibrary.find((f) => f.id === noteId)
      if (note) {
        setSelectedNote(note)
        setShowNoteModal(true)
      }
    } else {
      setShowNoteModal(false)
      setSelectedNote(null)
    }
  }, [location.pathname, library.files]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (params.id) {
      dispatch(libraryActions.fetchFileAssignedGroups(params.id))
    }

    if (!groupOrgs || (groupOrgs && !groupOrgs.length)) {
      dispatch(fetchOrgGroups())
    }

    if (!groups.length) {
      dispatch(fetchGroups())
    }

    if (!user.users.length) {
      dispatch(fetchUsers())
    }

    if (!stores?.length) {
      dispatch(fetchStores())
    }
    if (roles && !roles.length) {
      dispatch(fetchRoles())
    }
    // dispatch(fetchCourseSettings())
    dispatch(libraryActions.fetchAllFolders())
    dispatch(libraryActions.fetchLibraryFolderRoles())

    return () => {
      dispatch(libraryActions.onSearchReset())
    }
  }, [])

  const handleItemClick = (e, item) => {
    e.preventDefault()
    if (item.is_note === 1) {
      history.push('/library/note/' + item.id)
    } else if (item.type === 'folder') {
      history.push('/library/folder/' + item.id)
    }
  }

  const roleFilter = (item) => {
    let value
    if (library.selectedRole && item?.scope === 'private') {
      const folderWithRole = library.libraryFolderRoles
        .filter(
          (folder) =>
            parseInt(folder.role_id) === library.selectedRole.option.id,
        )
        .map((folder) => folder.folder_id)

      if (folderWithRole.includes(item?.id)) {
        value = true
      }
    } else if (item?.scope === 'public') {
      value = true
    } else {
      value = false
    }

    return value
  }

  const [isOpen, setIsOpen] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState(null)
  const [activeFilters, setActiveFilters] = useState([]) // [{ filter, item }]
  const [filterLoading, setFilterLoading] = useState(false)
  const filterSubmenuRef = useRef(null)

  const toggleDropdown = () => {
    setIsOpen(!isOpen)
  }

  const handleSelect = (filter) => {
    setSelectedFilter(filter)
  }

  const secondLevelItems = {
    Brands: groupOrgs,
    Locations: stores,
  }

  const isFilterSelected = (category, id) =>
    activeFilters.some((f) => f.filter === category && f.item?.id === id)

  const toggleFilter = (category, item) => {
    setActiveFilters((prev) =>
      prev.some((f) => f.filter === category && f.item?.id === item?.id)
        ? prev.filter(
            (f) => !(f.filter === category && f.item?.id === item?.id),
          )
        : [...prev, { filter: category, item }],
    )
  }

  const filterCount = (category) =>
    activeFilters.filter((f) => f.filter === category).length

  useEffect(() => {
    let cancelled = false
    setFilterLoading(activeFilters.length > 0)
    Promise.resolve(
      dispatch(
        filterFilesMulti(
          activeFilters.map((f) => ({ filter: f.filter, id: f.item?.id })),
        ),
      ),
    ).finally(() => {
      if (!cancelled) setFilterLoading(false)
    })
    return () => {
      cancelled = true
    }
  }, [dispatch, activeFilters])

  const filteredFileIdSet = new Set(
    (library.filteredFilesIds || []).map((f) => Number(f.file_id)),
  )
  const filteredFiles = activeFilters.length
    ? filterLoading
      ? []
      : library.files.filter((file) => filteredFileIdSet.has(Number(file.id)))
    : library.files

  useEffect(() => {
    if (selectedFilter) {
      // keep the submenu open while ticking several brands / locations
      const handleClickOutside = (e) => {
        if (filterSubmenuRef.current?.contains(e.target)) return
        setSelectedFilter(null)
      }

      // React 18 runs this effect synchronously during the click that opened
      // the submenu, so attach the listener on the next tick — otherwise that
      // same click reaches `document` and closes the submenu immediately.
      const timer = setTimeout(() => {
        document.addEventListener('click', handleClickOutside)
      }, 0)

      return () => {
        clearTimeout(timer)
        document.removeEventListener('click', handleClickOutside)
      }
    }
  }, [selectedFilter])

  return (
    <Container className='mt--6' fluid>
      <Card className='py-4 px-3' style={{ minHeight: '85vh' }}>
        {library.isLoading ? (
          <div
            className='dFlex justifyCenter itemsCenter textCenter'
            style={{ minHeight: '80vh' }}
          >
            <Loader />
          </div>
        ) : (
          <>
            <CardHeader className='d-flex flex-column' style={{ gap: '25px' }}>
              {userAccess === 1 && (
                <div
                  className='top-wrapper row'
                  style={{
                    justifyContent: 'space-between',
                    marginLeft: '0',
                    flexWrap: 'nowrap',
                  }}
                >
                  <div className='select-job-role'>
                    <div className='d-flex flex-column align-items-start width-md-75 width-sm-100'>
                      {(userAccess === 1 || allowSwitchRoles > 0) && (
                        <div className='w-100'>
                          <Select
                            options={roles}
                            selectedOptions={library.selectedRole}
                            onChange={(role) => dispatch(selectRole(role))}
                            language={language}
                            placeholder='Select Job Role'
                            multi={false}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className='search-grid-view-wrapper col-sm-9 col-xs-6'>
                    <div className='row justify-content-end'>
                      <div className='filters-container'>
                        <div className='filters-search-container'>
                          {userAccess === 1 && (
                            <div
                              className={'grid-view d-flex justify-content-end'}
                            >
                              {/*Btn*/}
                              <Button
                                className='btn-icon-only mr-2 toggle-view-button'
                                color={gridView ? 'info' : 'gray'}
                                onClick={() => setGridView(true)}
                                type='button'
                                outline
                                size='sm'
                              >
                                <span className='btn-inner--icon'>
                                  <FontAwesomeIcon icon={faTableCells} />
                                </span>
                              </Button>

                              {/*Btn*/}
                              <Button
                                className='btn-icon-only  toggle-view-button mr-2'
                                color={!gridView ? 'info' : 'gray'}
                                onClick={() => setGridView(false)}
                                type='button'
                                outline
                                size='sm'
                              >
                                <span className='btn-inner--icon'>
                                  <FontAwesomeIcon icon={faTableList} />
                                </span>
                              </Button>
                            </div>
                          )}

                          {userAccess === 1 ? (
                            <div className={'d-flex justify-content-end'}>
                              <Search
                                placeholder={
                                  language?.my_library?.search_files_folders
                                }
                                value={library.searchValue}
                                onChange={(event) =>
                                  dispatch(
                                    libraryActions.setSearchValue(
                                      event.target.value,
                                    ),
                                  )
                                }
                                onClick={() =>
                                  dispatch(libraryActions.onClickSearch())
                                }
                                handleKeyDown={(event) =>
                                  event.key === 'Enter'
                                    ? dispatch(libraryActions.onClickSearch())
                                    : null
                                }
                              />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className='bottom-wrapper mt-2 d-flex justify-content-between'>
                <div className='filter-by-wrapper d-flex align-items-center'>
                  <BreadCrumb
                    userAccess={userAccess}
                    allowSwitchRoles={allowSwitchRoles}
                    roles={roles}
                    library={library}
                    language={language}
                    user={user}
                    {...libraryActions}
                  />
                  {[1, 2, 4, 5].includes(userAccess) && (
                    <div
                      style={{ position: 'relative', display: 'inline-block' }}
                    >
                      {/* First-level dropdown */}
                      <Dropdown isOpen={isOpen} toggle={toggleDropdown}>
                        <DropdownToggle
                          className='btn btn-info ml-1'
                          style={{
                            padding: '0.625rem 1.25rem',
                            fontSize: '14px',
                          }}
                          role='button'
                          size='sm'
                        >
                          {activeFilters.length
                            ? `Filter By (${activeFilters.length})`
                            : 'Filter By'}
                        </DropdownToggle>
                        <DropdownMenu className='dropdown-menu-arrow'>
                          {['Brands', 'Locations'].map((category) => (
                            <DropdownItem
                              key={category}
                              onClick={() => handleSelect(category)}
                            >
                              <div className='d-flex justify-content-between align-items-center'>
                                <span>
                                  {FILTER_LABELS[category]}
                                  {filterCount(category) > 0 &&
                                    ` (${filterCount(category)})`}
                                </span>
                                <FontAwesomeIcon icon={faArrowRight} />
                              </div>
                            </DropdownItem>
                          ))}
                          {activeFilters.length > 0 && (
                            <>
                              <DropdownItem divider />
                              <DropdownItem
                                className='text-danger'
                                onClick={() => {
                                  setActiveFilters([])
                                  setSelectedFilter(null)
                                }}
                              >
                                Clear filters
                              </DropdownItem>
                            </>
                          )}
                        </DropdownMenu>
                      </Dropdown>

                      {selectedFilter && (
                        <div ref={filterSubmenuRef}>
                          <DropdownMenu
                            className='dropdown-menu-arrow'
                            style={{
                              position: 'absolute',
                              top: '0',
                              left: '100%',
                              marginTop: '0',
                              marginLeft: '0.5rem',
                              display: 'block',
                              maxHeight: '500px',
                              overflowY: 'auto',
                            }}
                          >
                            {(secondLevelItems[selectedFilter] || []).length ? (
                              secondLevelItems[selectedFilter].map(
                                (item, index) => (
                                  <div
                                    key={index}
                                    onClick={() =>
                                      toggleFilter(selectedFilter, item)
                                    }
                                    className='dropdown-item'
                                    role='button'
                                  >
                                    <div className='d-flex justify-content-between align-items-center'>
                                      <span>{item?.name}</span>
                                      {isFilterSelected(
                                        selectedFilter,
                                        item?.id,
                                      ) && <FontAwesomeIcon icon={faCheck} />}
                                    </div>
                                  </div>
                                ),
                              )
                            ) : (
                              <div
                                className='dropdown-item text-muted'
                                style={{ cursor: 'default' }}
                              >
                                {selectedFilter === 'Brands'
                                  ? 'No location groups found'
                                  : 'No locations found'}
                              </div>
                            )}
                          </DropdownMenu>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                {userAccess !== 1 && (
                  <div className={'d-flex'}>
                    <div className={'grid-view d-flex justify-content-end'}>
                      {/*Btn*/}
                      <Button
                        className='btn-icon-only mr-2 toggle-view-button'
                        color={gridView ? 'info' : 'gray'}
                        onClick={() => setGridView(true)}
                        type='button'
                        outline
                        size='sm'
                      >
                        <span className='btn-inner--icon'>
                          <FontAwesomeIcon icon={faTableCells} />
                        </span>
                      </Button>

                      {/*Btn*/}
                      <Button
                        className='btn-icon-only  toggle-view-button mr-2'
                        color={!gridView ? 'info' : 'gray'}
                        onClick={() => setGridView(false)}
                        type='button'
                        outline
                        size='sm'
                      >
                        <span className='btn-inner--icon'>
                          <FontAwesomeIcon icon={faTableList} />
                        </span>
                      </Button>
                    </div>
                    <div
                      // className="reorder-courses-wrapper mt-md-2 mt-xl-0"
                      style={{
                        marginLeft: '10px',
                        // width: "230px",
                      }}
                    >
                      <Search
                        placeholder={language?.my_library?.search_files_folders}
                        value={library.searchValue}
                        onChange={(event) =>
                          dispatch(
                            libraryActions.setSearchValue(event.target.value),
                          )
                        }
                        onClick={() => dispatch(libraryActions.onClickSearch())}
                        handleKeyDown={(event) =>
                          event.key === 'Enter'
                            ? dispatch(libraryActions.onClickSearch())
                            : null
                        }
                      />
                    </div>
                  </div>
                )}

                <div className={`filters`}>
                  {/*<div className={"grid-view col-lg-1 col-sm-6 px-0"}>*/}
                  {/*Btn*/}
                  {[1].includes(userAccess) ? (
                    <div className={'filter-button_container'}>
                      {/*// <div className="reorder-courses-wrapper mr-2">*/}
                      <div className='library-button mr-0 w-100 '>
                        <Button
                          color='white'
                          className='filter-button border-none px-3 py-2 w-100 w-sm-0 d-flex justify-content-center align-items-center reorder-button'
                          size='sm'
                          type='button'
                          onClick={(e) => {
                            dispatch(libraryActions.toggleLibraryOrder())
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faArrowsAltV}
                            className='mr-0'
                          />
                          <span className={'ml-2 filter-title'}>
                            Reorder items
                          </span>
                        </Button>
                        {library.showLibraryReorder ? (
                          <ReoderItems
                            language={language}
                            library={library}
                            itemIndex={library.itemIndex}
                            courseIndex={groups.courseIndex}
                            {...libraryActions}
                          />
                        ) : null}
                      </div>
                    </div>
                  ) : null}

                  {userAccess === 1 ? (
                    <>
                      <div className={'filter-button_container'}>
                        {/*Btn*/}
                        <Link
                          to='/library/upload'
                          className='library-button w-100'
                          style={{
                            // height: '30px',
                            color: '#172b4d',
                          }}
                        >
                          <Button
                            color='white'
                            className='filter-button  border-none px-3 py-2 w-100 d-flex justify-content-center align-items-center'
                            size='sm'
                            type='button'
                          >
                            <FontAwesomeIcon
                              icon={faFileMedical}
                              className='mr-0'
                            />
                            <span className={'ml-2 filter-title'}>
                              Add Content
                            </span>
                          </Button>
                        </Link>
                      </div>
                      <div className={'filter-button_container'}>
                        <>
                          {/*Btn*/}
                          <Link
                            to='/library/add-url'
                            // onClick={() => setShowUrlModal(!showUrlModal)}
                            className='library-button w-100'
                            style={{
                              // height: '30px',
                              color: '#172b4d',
                            }}
                          >
                            <Button
                              color='white'
                              className='filter-button  border-none px-3 py-2 w-100 d-flex justify-content-center align-items-center'
                              size='sm'
                              type='button'
                            >
                              <FontAwesomeIcon icon={faLink} className='mr-0' />
                              <span className={'ml-2 filter-title'}>
                                {' '}
                                Add Url
                              </span>
                            </Button>
                          </Link>
                        </>
                      </div>
                      <div className={'filter-button_container'}>
                        {/*Btn*/}
                        <Link
                          to='/library/add-folder'
                          className='library-button w-100'
                          style={{
                            // height: '30px',
                            color: '#172b4d',
                          }}
                        >
                          <Button
                            color='white'
                            className='filter-button  border-none px-3 py-2 w-100 d-flex justify-content-center align-items-center '
                            size='sm'
                            type='button'
                          >
                            <FontAwesomeIcon
                              icon={faFolderPlus}
                              className='mr-0'
                            />
                            <span className={'ml-2 filter-title'}>
                              {' '}
                              Add folder
                            </span>
                          </Button>
                        </Link>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </CardHeader>
            <div className='row mt-3 px-3'>
              {library.searchValueOnClick || library.selectedRole ? (
                library.searchValueOnClick && library.selectedRole ? (
                  filteredFiles
                    .filter(
                      (item) =>
                        item?.name &&
                        item?.name
                          .toLowerCase()
                          .indexOf(library.searchValueOnClick.toLowerCase()) !==
                          -1 &&
                        roleFilter(item),
                    )
                    .map((item) => (
                      <LibItem
                        gridView={gridView}
                        userAccess={userAccess}
                        language={language}
                        item={item}
                      />
                    ))
                ) : library.searchValueOnClick && !library.selectedRole ? (
                  library.allLibrary
                    .filter(
                      (item) =>
                        item?.name &&
                        item?.name
                          .toLowerCase()
                          .indexOf(library.searchValueOnClick.toLowerCase()) !==
                          -1,
                    )
                    .map((item) => (
                      <LibItem
                        gridView={gridView}
                        userAccess={userAccess}
                        language={language}
                        item={item}
                      />
                    ))
                ) : !library.searchValueOnClick && library.selectedRole ? (
                  filteredFiles
                    .filter((item) => roleFilter(item))
                    .map((item) => (
                      <LibItem
                        gridView={gridView}
                        userAccess={userAccess}
                        language={language}
                        item={item}
                      />
                    ))
                ) : (
                  ''
                )
              ) : filteredFiles && filteredFiles.length ? (
                filteredFiles.map((item) => (
                  <div
                    key={item?.id}
                    className={
                      // gridView ? "col-xs-12 col-sm-6 col-md-4 col-lg-3" : "col-12"
                      gridView
                        ? 'col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12'
                        : 'col-12'
                    }
                  >
                    {gridView ? (
                      <Card className='book-item shadow '>
                        {window.matchMedia('(min-width: 992px)').matches &&
                        userAccess === 1 ? (
                          <Link
                            to={`/library/${item?.id}/edit`}
                            className='btn btn-info btn-sm course-edit-btn'
                          >
                            <FontAwesomeIcon icon={faEdit} />
                            <span>
                              {language.general ? language.general?.edit : null}
                            </span>
                          </Link>
                        ) : null}
                        {item?.type && item?.type === 'folder' ? (
                          item?.thumb ? (
                            <div
                              onClick={() =>
                                history.push('/library/folder/' + item?.id)
                              }
                              className='book-image-wrapper'
                              style={{
                                backgroundImage: `url(${
                                  item?.thumb || item?.path
                                })`,
                                backgroundSize: 'cover',
                                cursor: 'pointer',
                              }}
                            ></div>
                          ) : (
                            <div
                              onClick={() =>
                                history.push('/library/folder/' + item?.id)
                              }
                              className='book-image-wrapper folder-item'
                            >
                              <FontAwesomeIcon
                                className='text-info'
                                icon={faFolder}
                                size='5x'
                              />
                            </div>
                          )
                        ) : item.is_note === 1 ? (
                          // Handle notes - show note icon and open modal on click
                          item?.thumb ? (
                            <div
                              onClick={(e) => handleItemClick(e, item)}
                              className='book-image-wrapper'
                              style={{
                                backgroundImage: `url(${
                                  item?.thumb || item?.path
                                })`,
                                backgroundSize: 'cover',
                                cursor: 'pointer',
                              }}
                            ></div>
                          ) : (
                            <div
                              className='book-image-wrapper folder-item'
                              onClick={(e) => handleItemClick(e, item)}
                              style={{ cursor: 'pointer' }}
                            >
                              <FontAwesomeIcon
                                className='text-primary'
                                icon={faStickyNote}
                                size='5x'
                              />
                            </div>
                          )
                        ) : (
                          <FileLink item={item}>
                            {item?.thumb ? (
                              <div
                                className='book-image-wrapper'
                                style={{
                                  backgroundImage: `url(${
                                    item?.thumb || item?.path
                                  })`,
                                  backgroundSize: 'cover',
                                }}
                              ></div>
                            ) : (
                              <div className='book-image-wrapper no-thumb-files'>
                                <div>
                                  <FontAwesomeIcon
                                    className='text-info'
                                    icon={getItemIcon(item)}
                                    size='5x'
                                  />
                                </div>
                              </div>
                            )}
                          </FileLink>
                        )}
                        {item.is_note === 1 ? (
                          <div
                            className='book-footer'
                            onClick={(e) => handleItemClick(e, item)}
                            style={{ cursor: 'pointer' }}
                          >
                            <CardFooter className='py-2 text-center'>
                              <h5 className='mt-2' title={item?.name}>
                                {item?.name}
                              </h5>
                            </CardFooter>
                          </div>
                        ) : item?.type === 'folder' ? (
                          <Link
                            to={`/library/folder/${item?.id}`}
                            className='book-footer'
                          >
                            <CardFooter className='py-2 text-center'>
                              <h5 className='mt-2' title={item?.name}>
                                {item?.name}
                              </h5>
                            </CardFooter>
                          </Link>
                        ) : (
                          <FileLink item={item} className='book-footer'>
                            <CardFooter className='py-2 text-center'>
                              <h5 className='mt-2' title={item?.name}>
                                {item?.name}
                              </h5>
                            </CardFooter>
                          </FileLink>
                        )}
                      </Card>
                    ) : (
                      <Card className='shadow'>
                        <CardBody className='pl-0 py-0'>
                          <Row className='align-items-center '>
                            <Col className='col-4 col-sm-3 col-md-3 col-lg-2 p-0 border-right'>
                              {item?.type && item?.type === 'folder' ? (
                                item?.thumb ? (
                                  <div
                                    onClick={() =>
                                      history.push(
                                        '/library/folder/' + item?.id,
                                      )
                                    }
                                    className='book-image-wrapper-toggled'
                                    style={{
                                      backgroundImage: `url(${
                                        item?.thumb || item?.path
                                      })`,
                                      backgroundSize: 'cover',
                                      cursor: 'pointer',
                                    }}
                                  ></div>
                                ) : (
                                  <div
                                    onClick={() =>
                                      history.push(
                                        '/library/folder/' + item?.id,
                                      )
                                    }
                                    className='book-image-wrapper-toggled folder-item d-flex align-items-center justify-content-center'
                                  >
                                    <FontAwesomeIcon
                                      className='text-info'
                                      icon={faFolder}
                                      size='5x'
                                    />
                                  </div>
                                )
                              ) : item.is_note === 1 ? (
                                // Handle notes in list view
                                item?.thumb ? (
                                  <div
                                    onClick={(e) => handleItemClick(e, item)}
                                    className='book-image-wrapper-toggled'
                                    style={{
                                      backgroundImage: `url(${
                                        item?.thumb || item?.path
                                      })`,
                                      backgroundSize: 'cover',
                                      cursor: 'pointer',
                                    }}
                                  ></div>
                                ) : (
                                  <div
                                    className='book-image-wrapper-toggled folder-item d-flex align-items-center justify-content-center'
                                    onClick={(e) => handleItemClick(e, item)}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <FontAwesomeIcon
                                      className='text-primary'
                                      icon={faStickyNote}
                                      size='5x'
                                    />
                                  </div>
                                )
                              ) : (
                                <FileLink item={item}>
                                  {item?.thumb ? (
                                    <div
                                      className='book-image-wrapper-toggled'
                                      style={{
                                        backgroundImage: `url(${
                                          item?.thumb || item?.path
                                        })`,
                                        backgroundSize: 'cover',
                                      }}
                                    ></div>
                                  ) : (
                                    <div className='book-image-wrapper-toggled no-thumb-files d-flex align-items-center justify-content-center'>
                                      <div>
                                        <FontAwesomeIcon
                                          className='text-info ml-2'
                                          icon={getItemIcon(item)}
                                          size='5x'
                                        />
                                      </div>
                                    </div>
                                  )}
                                </FileLink>
                              )}
                            </Col>
                            <div className='ml-2 mt-3 col align-self-start'>
                              {item.is_note === 1 ? (
                                <div
                                  onClick={(e) => handleItemClick(e, item)}
                                  className='book-footer'
                                  style={{ cursor: 'pointer' }}
                                >
                                  <h4 className='' title={item?.name}>
                                    {item?.name}
                                  </h4>
                                </div>
                              ) : item?.type === 'folder' ? (
                                <div
                                  onClick={() =>
                                    history.push('/library/folder/' + item?.id)
                                  }
                                  className='book-footer'
                                  style={{ cursor: 'pointer' }}
                                >
                                  <h4 className='' title={item?.name}>
                                    {item?.name}
                                  </h4>
                                </div>
                              ) : (
                                <FileLink item={item} className='book-footer'>
                                  <h4 className='' title={item?.name}>
                                    {item?.name}
                                  </h4>
                                </FileLink>
                              )}
                            </div>
                            {userAccess === 1 && (
                              <Col className='col-auto'>
                                <Link to={`/library/${item?.id}/edit`}>
                                  <Button
                                    className='btn-icon-only ml-2 edit-item-button'
                                    color='info'
                                    type='button'
                                    outline
                                    size='sm'
                                  >
                                    <span className='btn-inner--icon'>
                                      <FontAwesomeIcon icon={faEdit} />
                                    </span>
                                  </Button>
                                </Link>
                                <Button
                                  className='btn-icon-only ml-2 edit-item-button'
                                  color='danger'
                                  onClick={() =>
                                    dispatch(
                                      libraryActions.deleteFile(item?.id),
                                    )
                                  }
                                  type='button'
                                  outline
                                  size='sm'
                                >
                                  <span className='btn-inner--icon'>
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                  </span>
                                </Button>
                              </Col>
                            )}
                          </Row>
                        </CardBody>
                      </Card>
                    )}
                  </div>
                ))
              ) : (
                <div className='no-library-items'>
                  <p className='h4 my-5'>
                    {language.my_library ? language.my_library.no_items : null}
                  </p>
                </div>
              )}

              {location.pathname !== '/library' &&
              library.fileUploadStatus === 'uploaded' ? (
                <Redirect
                  to={
                    library.parentId
                      ? '/library/folder/' + library.parentId
                      : '/library'
                  }
                />
              ) : null}

              {userAccess === 1 ? (
                <Route
                  exact
                  path='/library/:id/edit'
                  render={(routeProps) => {
                    return (
                      <UpdateFile
                        courseConfig={courseConfig}
                        users={user?.users}
                        library={library}
                        roles={roles}
                        stores={stores}
                        groupOrgs={groupOrgs}
                        locationGroups={groups}
                        language={language}
                        gridView={gridView}
                        {...libraryActions}
                        {...routeProps}
                      />
                    )
                  }}
                />
              ) : null}

              {userAccess === 1 ? (
                <>
                  <Route
                    path='/library/upload'
                    render={(routeProps) => {
                      return (
                        <Upload
                          courseConfig={courseConfig}
                          users={user?.users}
                          library={library}
                          roles={roles}
                          stores={stores}
                          groupOrgs={groupOrgs}
                          locationGroups={groups}
                          language={language}
                          {...libraryActions}
                          {...routeProps}
                        />
                      )
                    }}
                  />
                  <Route
                    path='/library/add-url'
                    render={(routeProps) => {
                      return (
                        <Upload
                          courseConfig={courseConfig}
                          users={user?.users}
                          library={library}
                          roles={roles}
                          stores={stores}
                          groupOrgs={groupOrgs}
                          locationGroups={groups}
                          language={language}
                          {...libraryActions}
                          {...routeProps}
                          title='Add URL'
                          chooseFile={false}
                          inputPlaceHolder='https://fileurl.com'
                        />
                      )
                    }}
                  />
                </>
              ) : null}

              {userAccess === 1 ? (
                <Route
                  path='/library/add-folder'
                  render={(routeProps) => {
                    return (
                      <AddFolder
                        courseConfig={courseConfig}
                        users={user?.users}
                        library={library}
                        roles={roles}
                        stores={stores}
                        groupOrgs={groupOrgs}
                        locationGroups={groups}
                        language={language}
                        {...libraryActions}
                        {...routeProps}
                      />
                    )
                  }}
                />
              ) : null}
              <Route
                path='/library/upload-homework'
                render={(routeProps) => {
                  return (
                    <UploadHomework
                      library={library}
                      language={language}
                      {...routeProps}
                    />
                  )
                }}
              />
              <Route
                path='/library/url/:id'
                render={(routeProps) => {
                  return (
                    <UrlModal
                      library={library.files}
                      parentId={library.parentId}
                      language={language}
                      showUrlModal={showUrlModal}
                      setShowUrlModal={setShowUrlModal}
                      {...routeProps}
                    />
                  )
                }}
              />
              <Route
                path='/library/view-pdf'
                render={(routeProps) => {
                  return <ViewLibraryPDF {...routeProps} />
                }}
              />
            </div>
            <MyDocuments
              library={library}
              language={language}
              gridView={gridView}
            />
          </>
        )}
      </Card>

      {/* Note Modal */}
      <ViewNote
        isOpen={showNoteModal}
        toggle={() => {
          const backPath = library.parentId
            ? `/library/folder/${library.parentId}`
            : '/library'
          history.push(backPath)
        }}
        note={selectedNote}
        language={language}
      />

      <AreYouSureModal />
    </Container>
  )
}

export default Library
